import styled from '@emotion/styled';

export const Header = styled.header`
  display: flex;
  align-items: center;

  padding: 22px 48px;
`;
